module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "parallax-area"
  }, [_c('div', {
    ref: "inner",
    staticClass: "parallax-inner"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7d424aac!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/parallax-area/index.vue
// module id = 2091
// module chunks = 2